export const Menus = [
  {
    label: '회사소개',
    anchor: 'companyInfo',
    pathname: '/',
  },
  {
    label: '제품소개',
    anchor: 'productInfo',
    pathname: '/',
  },
  {
    label: '스탬프투어',
    anchor: 'stampTour',
    pathname: '/',
  },
  {
    label: '나의발자취',
    anchor: 'myPage',
    pathname: '/',
  },
  {
    label: '고객센터',
    anchor: 'customerService',
    pathname: '/',
  },
];

export const Dropdown = [
  {
    label: '회사소개',
    title: 'companyInfo',
    down: [
      {
        label: '(주)두원시스템',
        path: '/aboutdw',
      },
      {
        label: 'CEO 메시지',
        path: '/ceoMsg',
      },
      {
        label: '회사연혁',
        path: '/CompHistory',
      },
      {
        label: '경영철학',
        path: '/philosophy',
      },
    ],
  },
  {
    label: '제품소개',
    title: 'productInfo',
    down: [
      {
        label: '두원 스탬프투어',
        path: '/doowon',
      },
      {
        label: '스탬프',
        path: '/stamp',
      },
      {
        label: '스탬프 인증대',
        path: '/verify',
      },
      {
        label: '스탬프북',
        path: '/stampbook',
      },
      {
        label: '기념품',
        path: '/souvenir',
      },
    ],
  },
  {
    label: '스탬프투어',
    title: 'stampTour',
    down: [
      {
        label: '공지사항',
        path: '/notice',
      },
      {
        label: '이벤트',
        path: '/evtnoti',
      },
      {
        label: '대한민국 스탬프투어',
        path: '/TourMap',
      },
    ],
  },
  {
    label: '나의발자취',
    title: 'myPage',
    down: [
      {
        label: '마이페이지',
        path: '/mypage',
      },
      {
        label: '회원정보수정',
        path: '/profile',
      },
    ],
  },
  {
    label: '고객센터',
    title: 'customerService',
    down: [
      {
        label: '1:1 문의하기',
        path: '/Inquiry',
      },
      {
        label: 'FAQ',
        path: '/faq',
      },
      {
        label: '찾아오시는 길',
        path: '/Contactus',
      },
      {
        label: '자료실',
        path: '/download',
      },
    ],
  },
];

export default Menus;
